<template>
  <v-bottom-navigation
    :value="value"
    color="primary"
    horizontal
    class="attendance-bottom"
    style="position: fixed;"
  >
    <v-btn
    to="/verification/list"
    >
      <span>列表</span>

      <v-icon>mdi-heart</v-icon>
    </v-btn>
    <v-btn
      :to="{ name: 'followVerification', params: { state: 1 ,is_follow:true} }"
    >
      <span>待我跟进</span>
      <v-icon>mdi-heart</v-icon>
    </v-btn>
    <v-btn
      :to="{ name: 'verificationList', params: { state: 2 ,is_verification:true} }"
    >
      <span>待我验证</span>
      <v-icon>mdi-heart</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
  export default {
    name: 'AttendanceFooter',
    data: () => ({ value: 1 }),
  }
</script>
<style>
.attendance-bottom {
  height: 20px;
  text-align:center;
  position: fixed;
  bottom: 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/layouts/components/VerificationFooter.vue